/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {markWidgetAsUsed} from '../api'

export const useMutationMarkWidgetAsUsed = createReactQueryMutationHook('markWidgetAsUsed', markWidgetAsUsed)
